// extracted by mini-css-extract-plugin
export default {"starsDiv":"Stars_starsDiv__+RWBC"};